import type DistinguishedFolderIdName from "owa-service/lib/contract/DistinguishedFolderIdName";
import { UNIFIED_INBOX_FOLDER_NAME_PREFIX } from "owa-folders-constants";

// Returns a unique folder ID for a unified inbox folder based on its name
// The folder ID is prefixed with 'UnifiedInbox:' to ensure uniqueness
export function getUniqueUnifiedInboxFolderId(folderName: DistinguishedFolderIdName): string {
    return UNIFIED_INBOX_FOLDER_NAME_PREFIX + folderName;
}
